'use client';

import type {FC} from 'react';
import {useLiveQuery} from 'next-sanity/preview';

import type {OrderFormSchema} from 'components/content-blocks/order-form/schema';
import {FullPageSpinner} from 'components/full-page-spinner';

import type {FormPricesQueryResult} from './query';
import {FORM_PRICES_QUERY} from './query';
import {OrderFormRender} from './render';

type Props = {
	section: OrderFormSchema;
};

export const OrderFormDraft: FC<Props> = ({section}) => {
	const [formPrices, loading] = useLiveQuery<FormPricesQueryResult>(null, FORM_PRICES_QUERY);

	if (loading) {
		return <FullPageSpinner />;
	}

	if (!formPrices) {
		return <div>Kunne ikke laste priser!</div>;
	}

	return <OrderFormRender formPrices={formPrices} section={section} />;
};
